import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IClient } from "../../types/client.type";

export interface ClientState {
    loading: boolean;
    loadingError: string;
    clients: IClient[];
}

const initialState: ClientState = {
    loading: false,
    loadingError: "",
    clients: []
};

const clientSlice = createSlice({
    name: "client",
    initialState,
    reducers: {
        setClientLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setClientLoadingError: (state, action: PayloadAction<string>) => {
            state.loadingError = action.payload;
        },
        populateClients: (state, action: PayloadAction<IClient[]>) => {
            state.clients = [...action.payload];
        },
        addClient: (state, action: PayloadAction<IClient>) => {
            state.clients.push(action.payload);
        }
    }
});

export const selectClients = (state: { client: ClientState }) => state.client.clients;

// Export actions
export const { setClientLoading, setClientLoadingError, populateClients, addClient } =
    clientSlice.actions;

export default clientSlice.reducer;
